import { Component, Inject, Input } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { BOOTSTRAP_DATA } from 'api/providers'
import { HelpService } from 'help'
import { IdentityService } from '../services/identity.service'
import { AppSidebarService } from 'main/services/appSidebar.service'
import { MediaPermissionsService } from 'media/module'
import { BootstrapData } from 'elements-sdk'
import { ReleaseNotesService } from 'common/util.releaseNotes/services/releaseNotes.service'
import { SocketService } from 'common/util/module'
import { ParametersService } from 'main/services/parameters.service'

import './appNavbar.component.global.scss'
import { DomSanitizer } from '@angular/platform-browser'

@Component({
  selector: 'app-navbar',
  templateUrl: './appNavbar.component.pug',
  styleUrls: ['./appNavbar.component.scss'],
  host: {
    '[class.navbar]': 'true',
    '[class.navbar-dark]': 'true',
  },
})
export class AppNavbarComponent {
  @Input() logoLink: string
  @Input() profileLink: string
  @Input() showSidebarToggle = true
  @Input() showTaskDropdowns = true

  impersonationActive = this.bootstrapData.impersonationActive
  helpPage: string|null

  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  logoURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.parameters.values.brandingLogo || '/assets/logo.svg')

  constructor (
    public appSidebar: AppSidebarService,
    public helpService: HelpService,
    public identity: IdentityService,
    public parameters: ParametersService,
    public releaseNotes: ReleaseNotesService,
    public socket: SocketService,
    private mediaPermissions: MediaPermissionsService,
    private sanitizer: DomSanitizer,
    @Inject(BOOTSTRAP_DATA) private bootstrapData: BootstrapData,
    router: Router,
  ) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // check if the new page has a helpnote
        this.helpPage = this.helpService.matchRouteToHelpNote(event.url)
      }
    })
  }

  ngOnInit () {
    this.showSidebarToggle = !this.appSidebar.hidden
    this.showTaskDropdowns ??=
      this.identity.hasPermission('fs:fm') ||
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      this.mediaPermissions.permissions.some(x => x.allowWriteFs || x.allowWriteDb) ||
      this.identity.hasPermission('tasks:view')
  }

  logout () {
    this.identity.logout()
  }

  async openHelp () {
    this.helpService.openHelp(this.helpPage!)
  }
}
